import styled from 'styled-components'
import variables from '../../styles/variables'

export const ContentStar = styled.div`
    display: flex;
    font-size: 2rem;
    margin: inherit;
    justify-content: center;
    

`
  